import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=37eccfa4&scoped=true"
import script from "./DistrictList.vue?vue&type=script&lang=js"
export * from "./DistrictList.vue?vue&type=script&lang=js"
import style0 from "./DistrictList.vue?vue&type=style&index=0&id=37eccfa4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eccfa4",
  null
  
)

export default component.exports